/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the UsersApiConfiguration configuration object with a given root URL.
 */
export function provideUsersApiConfiguration(rootUrl: string) {
  var config = new UsersApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: UsersApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class UsersApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `O2UsersApiModule.forRoot()`
 */
export interface UsersApiConfigurationParams {
  rootUrl?: string;
}
